import { render, staticRenderFns } from "./AssignOtherProviderModel.vue?vue&type=template&id=6bbb20ce"
import script from "./AssignOtherProviderModel.vue?vue&type=script&lang=js"
export * from "./AssignOtherProviderModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports